import React from 'react';
import {Navigate, useParams} from 'react-router-dom';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import SestCategoryDetail from '@di-shared/features/diag/sest/SestCategoryDetail';
import {SestCategory} from '@di-shared/features/diag/sest/const';
import environmentStore from '@di-shared/features/environment/environmentStore';
import {TranslationKey} from '@di-shared/i18next';
import {ROUTE_PATHS} from '@di-shared/routes';
import {WebviewUtils} from '@shared/webviewUtils';

interface SestCategoryDetailPageProps {
  vin: string;
}

const sestCategoryTitleMap = new Map([
  [SestCategory.ENGINE, 'T30050'],
  [SestCategory.BRAKE, 'T30051'],
  [SestCategory.AIR_CONDITIONER, 'T30052'],
  [SestCategory.COOLANT, 'T30053'],
]);

function getSestCategoryTitle(sestCategory: SestCategory): TranslationKey {
  return sestCategoryTitleMap.get(sestCategory) as TranslationKey;
}

function SestCategoryDetailPage({vin}: SestCategoryDetailPageProps) {
  const {t} = useInferableTranslation();
  const {sestCategory} = useParams();
  const ccid = environmentStore.getState().ccid;

  if (!sestCategory) {
    return <Navigate to={ROUTE_PATHS.HOME.getFullPath(vin)} />;
  }
  const title = t(getSestCategoryTitle(+sestCategory));

  function linkToMaintenanceAppointment() {
    WebviewUtils.openNewWebView({
      url: `${import.meta.env.VITE_CCI_DOMAIN}/maintenance/register/appointment?vin=${vin}`,
      isModal: true,
      isNavigationBar: true,
      isToolBar: false,
    });
  }

  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header
        left={<HeaderBackButton />}
        right={
          <button
            type="button"
            className="btn_text btn_small"
            onClick={() => linkToMaintenanceAppointment()}
          >
            {t('T30166_#short')}
          </button>
        }
      >
        <h1 className="title_xsmall_b nav_center_title">{title}</h1>
      </Header>
      <SestCategoryDetail
        sestCategory={+sestCategory}
        vin={vin}
        ccid={ccid}
      />
    </div>
  );
}

export default SestCategoryDetailPage;
